import React from 'react';
import Radium from 'radium';
import {Device, ElementIsInViewPort, lightGray, darkGray} from './modules/shared.js';

import Herosection from './modules/herosection';
import Article from './modules/article';
import ContactArticle from './modules/contact-article';
import Navigation from './modules/navigation';
import Impress from './modules/impress';

import ContentService from './services/ContentService';

class App extends React.Component {
  constructor() {
    super();
    this.state = { 
      activeNavPoint: 0,
      open: false,
    };
    this.articles = ContentService.getArticles();
    this.articleRefs = [];
  }

  componentDidMount() {
    const eventHandler = () => {
      this.articleRefs.some((el, index) => {
        try {
          if (ElementIsInViewPort(el.refs.headline)) {
            this.setState({ 'activeNavPoint': index });
            return true;
          }
        } catch (e) {}
        return false;
      });
    };
    document.addEventListener('scroll', eventHandler.bind(this));
  }

  toggleMobileNav() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const articleComponents = this.articles.map((content, index) => {
      return (
        <Article 
          ref={ (el) => this.articleRefs.push(el) }
          headlineId={ `article${ index }` }
          key={ content.headline }
          content={ content } />
      );
    });

    const transitionTiming = '.3s';
    const transformationAmount = '100px';
    const footerHeight = 40;
    const style = {
      articles: {
        position: 'relative',
        zIndex: 0,
        left: this.state.open && !Device.isMobile() ? transformationAmount : 0,
        transitionProperty: 'left',
        transitionDuration: transitionTiming,
        transitionDelay: transitionTiming,
        transitionTiming: 'linear',
        padding: '30px 0 0',
      },
      app: {
        width: '100%',
        overflowX: 'hidden',
        backgroundColor: lightGray,
      },
      footer: {
        position: 'relative',
        width: '100%',
        backgroundColor: darkGray,
        height: footerHeight,
        marginTop: 90,
        span: {
          color: "#fff",
          fontWeight: 300,
          fontSize: 12,
          textAlign: 'center',
          position: 'relative',
          width: '100%',
          display: 'block',
          transform: `translateY(${ footerHeight / 3 }px)`,
        }
      },
    }

    return (
      <div 
        className="App"
        style={ style.app }>
        <Herosection />
        <Navigation 
          activeNavPoint={ this.state.activeNavPoint }
          articles={ this.articles.concat([{ headline: 'Kontakt' }, { headline: 'Impressum' }]) }
          toggleMobileNav={ this.toggleMobileNav.bind(this) }
          open={ this.state.open }
          transitionTiming={ transitionTiming }
        />
        <section style={ style.articles }>
          { articleComponents }
          <ContactArticle 
            headlineId={ `article${ this.articles.length }` }
            ref={ (el) => this.articleRefs.push(el) } />
          <Impress
            content={ ContentService.getImpress() }
            headlineId={ `article${ this.articles.length + 1 }` }
            ref={ (el) => this.articleRefs.push(el) } />
        </section>
        <footer style={style.footer}>
          <span style={style.footer.span}>
            created 2017 by <a href="https://jonathanstoye.de" target="_blank">jonathanstoye.de</a>
          </span>
        </footer>
      </div>
    );
  }
}

export default Radium(App);


// WEBPACK FOOTER //
// ./src/App.js